<template>
  <!-- upgrade modal -->
  <div v-if="UpgradeModal" class="upgrade-dialog">
    <v-dialog
      overlay-opacity="0.97"
      persistent
      v-model="UpgradeModal"
      max-width="350"
    >
      <v-card>
        <v-toolbar dense color="#00E676" class="text-h6" dark>
          Get Full Access
          <v-spacer></v-spacer>

          <v-btn icon @click="$emit('closeModal')">
            <v-icon color="red">mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="text-center text-h6 font-weight-bold pa-2">
          Upgrade Now & Get Access to ALL Features
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1 white--text"
            depressed
            @click="goToUpgrade"
          >
            Upgrade Now
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
  <!-- upgrade modal ends... -->
</template>

<script>
export default {
  name: "upgradePlanModal",

  props: {
    UpgradeModal: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    goToUpgrade() {
      this.$router.push({ name: "upgradePlan" });
    },
  },
};
</script>

<style></style>
